// extracted by mini-css-extract-plugin
module.exports = {"card":"topJobsNearYou_card__1sQum","card-item":"topJobsNearYou_card-item__AnOZ7"};